<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.searchValue" class="input-with-select" size="small">
                        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
							<el-option label="在路上酒店ID" :value="4"></el-option>
                            <el-option label="秀动酒店ID" :value="1"></el-option>
                            <el-option label="酒店名称" :value="2"></el-option>
                            <el-option label="绑定演出ID" :value="3"></el-option>
                        </el-select>
                    </el-input>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sortType" placeholder="请选择" size="small">
                        <el-option label="优先展示星级高的" :value="1"></el-option>
                        <el-option label="优先展示评分高的" :value="2"></el-option>
                        <el-option label="优先展示星级低的" :value="3"></el-option>
                        <el-option label="优先展示评分低的" :value="4"></el-option>
                    </el-select>
                </el-col> -->
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-cascader
                        v-model="areaCode"
                        :options="cityList"
                        filterable
                        :props="{label:'name',children:'cityList',value:'id', checkStrictly: true}"
                        size="small"
                        style="width:100%"
                        ref="cityCascader"
                        placeholder="选择省份/城市"
                        @change="cityChange"
                        clearable>
                    </el-cascader>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="id" label="酒店ID">
					<template slot-scope="scope">
						<p v-if="scope.row.hotelId">在路上：{{scope.row.hotelId}}</p>
						<p v-if="scope.row.id">秀动：{{scope.row.id}}</p>
					</template>
				</el-table-column>
                <el-table-column prop="name" label="酒店名称" min-width="150"></el-table-column>
                <el-table-column prop="province" label="所在省份"></el-table-column>
                <el-table-column prop="city" label="所在城市"></el-table-column>
               <!-- <el-table-column prop="starRate" label="星级"></el-table-column> -->
                <el-table-column prop="userScore" label="评分"></el-table-column>
                <el-table-column fixed="right" label="操作" width="100">
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="$refs.activityList.show(scope.row)"
                            >查看绑定演出</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
        <activity-list ref="activityList"></activity-list>
    </div>
</template>

<script>
import {fetchAllCity} from '@/assets/js/commonApi'
import ActivityList from './components/ActivityList.vue'
const defaultParams = {
    pageNo:1,
    searchType: 4,
    searchValue: '',
    areaType: 1,
    areaCode: '',
    sortType: 1
}
export default {
    components: {ActivityList},
    data(){
        return {
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo:parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
            },
            listLoading: false,
            cityList: [],
            areaCode: []
        }
    },
    created(){
        this.getCityList()
    },
    mounted() {
        this.getDataList();
    },
    methods:{
        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/hotel/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.areaCode = [];
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        cityChange(e){
            if( e.length == 1 ){
                this.params.areaType = 1
                this.params.areaCode = e[0]
            }else if(e.length == 2){
                this.params.areaType = 2
                this.params.areaCode = e[1]
            }else{
                this.params.areaType = 1
                this.params.areaCode = ""
            }
        }
    }
}
</script>

<style lang="scss" scoped>

</style>